import React from 'react';
import { getRateForJob } from 'utils/fieldglass';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface BuyerInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const BuyerInfoAccordion: React.FC<BuyerInfoAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : '-';

  const rate = getRateForJob(jobData);

  const mappedData = {
    company: striive_job ? getValue(striive_job.client_name) : '-',
    department: striive_job ? getValue(striive_job.department) : '-',
    currency: rate?.billAmountCurrency || 'USD',
    coordinatorName: striive_job
      ? getValue(striive_job.coordinator_full_name)
      : '-',
    supervisorName: striive_job
      ? getValue(striive_job.report_to_full_name)
      : '-',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion
      title="BUYER INFORMATION"
      expanded={expanded}
      onChange={onChange}
    >
      <Grid container spacing={3}>
        {renderDetailItem('Company:', mappedData.company)}
        {renderDetailItem('Department:', mappedData.department)}
        {renderDetailItem('Currency:', mappedData.currency)}
        {renderDetailItem('Coordinator Name:', mappedData.coordinatorName)}
        {renderDetailItem('Supervisor Name:', mappedData.supervisorName)}
      </Grid>
    </JobAccordion>
  );
};
